import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type { SxProps, Theme } from "@mui/material/styles";
import { formatDateTime, formatDayAgo, formatTimeAgo } from "@/app/date.utils";

const REFRESH_MS = 60 * 1000;

interface TimeAgoProps {
  iso: string | undefined;
  dayOnly?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * A timestamp as "5 minutes ago" while recent, then a date and time; with `dayOnly`, as "Today" /
 * "Yesterday" / the date. Hovering shows the full value; refreshes every minute.
 */
export const TimeAgo = (props: TimeAgoProps) => {
  const { iso, dayOnly, sx } = props;
  const [now, setNow] = useState(() => Date.now());
  let label = formatTimeAgo(iso, now);
  if (dayOnly) {
    label = formatDayAgo(iso, now);
  }
  const full = formatDateTime(iso);
  const tooltip = label === full ? "" : full;

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, REFRESH_MS);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Tooltip
      placement="top-start"
      title={tooltip}
    >
      <Typography
        noWrap
        sx={sx}
        variant="body2"
      >
        {label}
      </Typography>
    </Tooltip>
  );
};
